import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";

export function sendPageEvent(path = window.location.pathname) {
  // If the analytics was not loaded, we simply return
  if (window.digitalData?.events === undefined) return;

  const pageName = `tools${path}`;
  const dnow = Date.now();

  window.digitalData.events.push({
    event: {
      schema: "iglu:be.vrt/page_impression/jsonschema/1-1-0",
      data: {
        timestamp: dnow,
      },
    },
    context: [
      {
        schema: "iglu:be.vrt/context_page/jsonschema/1-2-1",
        data: {
          pagename: pageName,
          touchpointbrand: "vrt",
          contentbrand: "edubox",
          pageurl: window.location.href,
          pagetitle: "EDUbox Oorlog en vrede: tool",
          domain: "www.vrt.be",
          pagepath: pageName,
          pagelanguage: "nl",
          sitesection1: "",
          sitesection2: "",
          sitesection3: "EDUbox Oorlog en vrede",
          sitesection4: "",
          pageid: pageName,
        },
      },
    ],
  });
}

export function Analytics() {
  let location = useLocation();
  const [loaded, setLoaded] = useState(false);
  const intervalRef = useRef(null);

  // Only enable tracking in production
  if (!import.meta.env.PROD) return null;

  // We try to detect when the scripts are actually loaded AND parsed
  // That way we know when to sent out the first event
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      if (window.digitalData) {
        setLoaded(true);
        clearInterval(intervalRef.current);
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (loaded) sendPageEvent();
  }, [loaded]);

  useEffect(() => {
    sendPageEvent();
  }, [location]);

  return (
    <>
      <script
        src="https://t.vrt.be/latest/vrtebahelper.min.js"
        async
        defer
      ></script>
      <script src="https://t.vrt.be/latest/vrteba.min.js" async defer></script>
    </>
  );
}
